import create from 'zustand';
import _cloneDeep from 'lodash.clonedeep';
import { CONSTANTS } from 'utilities/configuration';

import { reportStructures } from 'utilities/configuration';

// Auth shenaningans
import { grantPermissionBase } from 'utilities/hooks/usePermissions';

const useReportNavigationStore = create((set, get) => ({
    // Rebuilds report items
    buildItems({
        initiativeType,
        reportType,
        permissionType = 'view',
        user = {},
    }) {
        if (user) {
            // Reset store
            get().reset();

            // Extract user data
            const {
                userAccountType,
                userInitiativeTeamRole,
                userAccountId,
            } = user;

            // Support fallback type
            const initativeStructureType = [
                'Advanced',
                'Default',
                'Reporting',
            ].includes(initiativeType)
                ? CONSTANTS.INITIATIVE.SOCIAL
                : initiativeType;

            // Report Type dictionary
            const reportTypeDictionary = {
                Status: 'Status',
                Annual: 'Annual',
                Final: 'Final',
                Standard: 'Annual',
                Extended: 'Final',
            };

            // Clone for immutability
            const clonedReportStructures = _cloneDeep(reportStructures);

            // Get structure based on context before authentication check
            let navigationStructure =
                clonedReportStructures?.[initativeStructureType]?.[
                    reportTypeDictionary[reportType]
                ]?.filter(
                    section =>
                        section.section && !section.hideSectionInReportView
                ) ?? [];

            // Loop through navigation structure
            let authenticatedNavigationStructure = [];
            for (let section of navigationStructure) {
                // Check all the section items
                if (section?.items?.length > 0) {
                    // New array for items that are authenticated
                    let authenticatedItems = [];
                    for (const item of section.items) {
                        // Push item to new array if permission is granted
                        if (
                            !item?.metaItem &&
                            grantPermissionBase(
                                item?.permissions[permissionType],
                                userAccountType,
                                userInitiativeTeamRole,
                                userAccountId
                            )
                        ) {
                            authenticatedItems.push(item);
                        }
                    }

                    // If there are any authenticated items except metaItems, show them
                    if (authenticatedItems.length > 0) {
                        // Overwrite section items with new items
                        section.items = authenticatedItems;

                        // Add to authenticated navigation struture
                        authenticatedNavigationStructure = [
                            ...authenticatedNavigationStructure,
                            section,
                        ];
                    }
                }
            }

            // Update state
            set(state => {
                state.items = authenticatedNavigationStructure;
            });
        }
    },

    hasSection(section) {
        // flatten items.items into a single array and search for string section in item.baseUrl
        return get()
            .items.reduce((acc, item) => {
                return [...acc, ...item.items];
            }, [])
            .some(item => item.baseUrl === section);
    },

    items: [],

    reset() {
        set(() => ({
            items: [],
        }));
    },
}));

export { useReportNavigationStore };
